import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "delete-modal",
  role: "alertdialog",
  "aria-modal": "true",
  "aria-labelledby": "delete-package-title",
  "aria-describedby": "delete-package-description"
}
const _hoisted_2 = { class: "delete-modal-actions" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "delete-modal" }, {
      default: _withCtx(() => [
        ($props.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "delete-modal-backdrop",
              onClick: _withModifiers($setup.close, ["self"])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _cache[1] || (_cache[1] = _createElementVNode("h2", { id: "delete-package-title" }, "Delete Package", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("p", { id: "delete-package-description" }, "Are you sure you want to delete this package? This action cannot be undone.", -1)),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("button", {
                    class: "cancel-button",
                    type: "button",
                    disabled: $props.deleting,
                    onClick: $setup.close
                  }, "Cancel", 8, _hoisted_3),
                  _createElementVNode("button", {
                    class: "delete-button",
                    type: "button",
                    disabled: $props.deleting,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
                  }, _toDisplayString($props.deleting ? "Deleting…" : "Delete"), 9, _hoisted_4)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}